import { FC } from 'react';

import { Box, Button, Stack } from '@mui/material';
import { Form, Formik } from 'formik';
import { CountryCode } from 'libphonenumber-js';
import * as Yup from 'yup';

import { PhoneNumberField } from 'src/components/FormikComponents';
import { formatToInternational } from 'src/lib/formatters';

interface EditPhoneNumberFormProps {
    phoneNumber: string;
    loading: boolean;
    updateUser: (args) => void;
    handleClose: () => void;
    countryCode: string;
}

const EditPhoneNumberForm: FC<EditPhoneNumberFormProps> = ({
    phoneNumber,
    loading,
    updateUser,
    handleClose,
    countryCode,
}) => {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Formik
                initialValues={{ phoneNumber: phoneNumber ?? '' }}
                validationSchema={Yup.object({
                    phoneNumber: Yup.string().required('Please provide a valid contact number.'),
                })}
                onSubmit={(values) => {
                    updateUser({
                        phoneNumber: formatToInternational(
                            values.phoneNumber.toString(),
                            countryCode as CountryCode
                        ),
                    });
                }}
            >
                {(formik) => {
                    return (
                        <Form>
                            <PhoneNumberField
                                {...formik}
                                formikFieldName="phoneNumber"
                                label="Phone Number"
                                placeholder="Enter Phone Number"
                                initialPhoneNumber={phoneNumber}
                                searchText="Validate"
                            />

                            <Stack
                                direction="row"
                                justifyContent="flex-end"
                                spacing={2}
                                sx={{ my: 3 }}
                            >
                                <Button
                                    variant="outlined"
                                    onClick={handleClose}
                                    sx={{
                                        borderColor: '#000',
                                        color: '#000',
                                        '&:hover': {
                                            bgcolor: '#000',
                                            color: '#fff',
                                            opacity: 0.8,
                                        },
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    disabled={loading || !formik.isValid}
                                    color="primary"
                                    sx={{
                                        bgcolor: '#000',
                                        color: '#fff',
                                        '&:hover': {
                                            bgcolor: '#000',
                                            color: '#fff',
                                            opacity: 0.8,
                                        },
                                    }}
                                >
                                    {loading ? 'Updating' : 'Update'}
                                </Button>
                            </Stack>
                        </Form>
                    );
                }}
            </Formik>
        </Box>
    );
};

export default EditPhoneNumberForm;
